export default __webpack_public_path__ + "static/martin-0dc2a2937d5c4db62f88a65b4269d081.png";